module.exports = __webpack_public_path__ + "static/media/Ad_NCA1.35fe7db2.jpg";